// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"4d3173df","455":"884e5d3b"}[chunkId] + ".chunk.js";
};